<template>
    <div class="foot-wrap">
        <div class="footer">
            <div class="f-top">
                <div class="f-left">
                    <img src="../assets/imgs/logo.png" />
                    <p>
                        <span>海量正品折扣货源</span>
                    </p>
                </div>
                <div class="f-right">
                    <ul>
                        <li>
                            <img src="../assets/imgs/2wm.png" />
                            <span>扫一扫 立即赚</span>
                        </li>
                        <li>
                            <img src="../assets/imgs/gzh.png" />
                            <span>爱库存公众号</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="f-bottom">
                ©2017-2019 上海众旦信息科技有限公司 |
                <img src="../assets/imgs/gh.png" />沪公网安备 31011502007771号 |
                沪ICP备17055106号
            </div>
        </div>
    </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
$w: 1120px;
$flex: flex;
@mixin boxsizing {
    box-sizing: border-box;
}

.foot-wrap {
    width: 100%;
    margin: 60px 0 0;
    background: #f9f9f9;
    height: 204px;
    padding: 26px 0 0;
    @include boxsizing;

    .footer {
        width: $w;
        margin: 0 auto;
        .f-top {
            display: $flex;
            flex-wrap: wrap;
            justify-content: space-between;
            padding: 0 0 18px;

            .f-left {
                display: $flex;
                align-items: center;
                img {
                    width: 155px;
                }
                p {
                    font-size: 20px;
                    color: #666;
                    margin-left: 28px;
                    span {
                        letter-spacing: 5px;
                    }
                }
            }

            .f-right {
                ul {
                    display: $flex;
                    li {
                        text-align: center;
                        font-size: 12px;
                        color: #999;
                        &:first-child {
                            margin: 0 30px 0 0;
                        }
                        img {
                            width: 80px;
                            height: 80px;
                            display: block;
                        }
                    }
                }
            }
        }

        .f-bottom {
            border-top: 1px solid #ccc;
            padding: 18px 0 0;
            text-align: center;
            color: #999;
            height: 20px;
            line-height: 20px;
            font-family: "黑体";
            font-size: 12px;
            img {
                display: inline-block;
                width: 12px;
                height: 12px;
                vertical-align: -2px;
            }
        }
    }
}
</style>
